<template>
  <div class="login-container">
    <div class="login-bg">
      <img :src="bgImg" alt="">
    </div>
    <van-form ref="form" class="tab-form" @submit="onSubmit">
      <div class="tabs-card" v-if="gameInfos">
        <van-tabs v-model="tabActive" @change="handleTabChange">
          <van-tab v-if="gameInfos && gameInfos.msg_type === 1" :title="$t('login.phoneLogin')" name="phone">
            <div v-if="tabActive === 'phone'">
              <van-field
                v-model="phone"
                :name="$t('login.phone')"
                :label="$t('login.phone')"
                :placeholder="$t('login.phone')"
                :rules="[
                    { required: true, message: $t('login.phoneRequired') },
                    { pattern:/^1[3-9]\d{9}$/, message: $t('login.rightPhone') }
                    ]"
              />
              <van-field
                  v-model="code"
                  :maxlength="6"
                  type="code"
                  :name="$t('login.code')"
                  :label="$t('login.code')"
                  :placeholder="$t('login.code')"
                  :rules="[{ required: true, message: $t('login.codeRequired') }]"
              >
                <template #button>
                  <van-button
                      native-type="button"
                      @click="getSms"
                      type="primary"
                      size="mini">{{ showTimer ? `${$t('login.reSend')}(${second}s)` : $t('login.sendCode') }}
                  </van-button>
                </template>
              </van-field>
            </div>
          </van-tab>
          <van-tab v-if="gameInfos && gameInfos.msg_type === 2" :title="$t('login.emailLogin')" name="email">
            <div v-if="tabActive === 'email'">
              <van-field
                v-model="email"
                :name="$t('login.email')"
                :label="$t('login.email')"
                :placeholder="$t('login.email')"
                :rules="[
                    { required: true, message: $t('login.emailRequired') },
                    { pattern:/\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, message: $t('login.rightEmail') }
                  ]"
              />
              <van-field
                  v-model="code"
                  type="code"
                  :name="$t('login.code')"
                  :label="$t('login.code')"
                  :placeholder="$t('login.code')"
                  :rules="[{ required: true, message: $t('login.codeRequired') }]"
              >
                <template #button>
                  <van-button
                      native-type="button"
                      @click="getSms"
                      type="primary"
                      size="mini">{{ showTimer ? `${$t('login.reSend')}(${second}s)` : $t('login.sendCode') }}
                  </van-button>
                </template>
              </van-field>
            </div>
          </van-tab>
        </van-tabs>
        <div class="marginB10 marginL10 marginT10 marginR10">
          <van-button
            class="login-btn"
            block
            type="primary"
            size="large"
            native-type="submit"
          >
            {{ $t('login.login') }}
          </van-button>
        </div>
      </div>
      <van-empty v-else :description="$t('login.请选择游戏')" />
    </van-form>
  </div>
</template>

<script>
  import {apiGetLoginCode, apiLogin,getRoleList, apiGameLogin} from '@/api/user';
  import storage from '@/utils/storage';
  import {loginBg} from './mixins';

  export default {
    mixins: [loginBg],
    data() {
      return {
        phone: '',
        email:'',
        code: '',
        showTimer: false,
        second: 0,
        timer: null,
        tabActive: 'phone'
      };
    },
    beforeDestroy() {
      this.clearTimer();
    },
    created() {
      const { game_id } = this.$route.query;
      if (game_id) {
        sessionStorage.setItem('game_id', Number(game_id));
      }
    },
    mounted () {
      this.getLoginBg().then(() => {
        this.tabActive = this.gameInfos && this.gameInfos.msg_type === 2 ? 'email' : 'phone';
      });
      // 判断是否为自动绑定角色用户
      this.autoBindRole();
    },
    methods: {
      // 自动绑定逻辑
      autoBindRole () {
        const { data, game_id } = this.$route.query;
        if (data) {
          const params = {
            data
          };
          if (game_id) {
            params.game_id = game_id;
          }
          this.showLoading();
          apiGameLogin(params).then(res => {
            if (res.code === 0) {
              storage.removeItem('token');
              storage.setItem('token', res.data.token);
              // sessionStorage.setItem('game_id', Number(res.data.game_id));
              // 判断是否有角色
              getRoleList().then(res => {
                if (res.code === 0) {
                  let redirect = this.$route.query.redirect || '';
                  let path = redirect || '/user-center';
                  // if (!res.data.length) {
                  //   path = '/bind-roles';
                  // }
                  this.$router.replace({ path, query: path ==='/bind-roles' ? {from: 'login'} : {}});
                // console.log(34555, this.$router);
                }
              });
            }
          }).finally(() => {
            this.hideLoading();
          });
        }
      },
      handleTabChange () {
        this.code = '';
      },
      getSms() {
        if (!this.phone && this.tabActive === 'phone') {
          this.$toast(this.$t('login.phoneRequired'));
          return;
        } else if (!this.email && this.tabActive === 'email'){
          this.$toast(this.$t('login.emailRequired'));
          return;
        }
        let params = {
          phone: this.phone,
          type: 'login'
        };
        if (this.tabActive === 'email'){
          params.email=this.email;
          delete params.phone;
        }
        if (!this.showTimer) {
          apiGetLoginCode(params).then(res => {
            if (res.code === 0) {
              this.showTimer = true;
              this.second = 60;
              this.timer = setInterval(() => {
                this.second = this.second - 1;
                if (this.second == 0) {
                  this.clearTimer();
                  return;
                }
              }, 1000);
            }
          });
        }
      },
      onSubmit() {
        let params = {
          code: Number(this.code),
        };
        if (this.tabActive === 'phone'){
          params.phone = this.phone;
        } else {
          params.email = this.email;

        }
        apiLogin(params).then(res => {
          if (res.code === 0) {
            storage.removeItem('token');
            storage.setItem('token', res.data.token);
            // 判断是否有角色
            getRoleList().then(res => {
              if (res.code === 0) {
                let redirect = this.$route.query.redirect || '';
                let path = redirect || '/user-center';
                if (!res.data.length) {
                  path = '/bind-roles';
                }
                this.$router.replace({ path, query: path ==='/bind-roles' ? {from: 'login'} : {}});
                // console.log(34555, this.$router);
              }
            });
          }
        });
      },
      // 清除定时器
      clearTimer() {
        this.showTimer = false;
        this.second = 0;
        clearInterval(this.timer);
      }
    },
  };
</script>

<style lang="less" scoped>
.login-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  .tab-form {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    .tabs-card{
      width: 100%;
      margin-top: 18px;
      overflow: hidden;
      background: #fff;
    }
  }
  .login-btn {
    height: 40px;
  }
  .login-bg {
    font-size: 0;
    img {
      width: 100%;
    }
  }
}
</style>
